import { Link } from "react-router-dom";
import Header from "../components/Header";
import FAQ from "../components/FAQ";
import { ArrowRight } from "@phosphor-icons/react";

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="faq-page">
      <Header />
      <main className="max-w-[1100px] mx-auto px-6 lg:px-10 py-16">
        <div className="pg-overline mb-3">Frequently asked questions</div>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter">
          Everything Kiwis ask<br/>before signing up<span className="text-[#002FA7]">.</span>
        </h1>
        <p className="text-[#52525b] text-base sm:text-lg leading-relaxed mt-6 max-w-2xl">
          Built for everyday New Zealand households. Real questions from real Kiwi shoppers, answered plainly. Browse the list below, or jump straight to "Honest answers before you sign up" further down if you want the short version.
        </p>
      </main>
      <FAQ />
      <section className="border-t border-[#e4e4e7] bg-[#f7f7f8]" data-testid="faq-cta-strip">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#e4e4e7] border border-[#e4e4e7]">
          <Link to="/signup" className="bg-[#002FA7] text-white p-8 hover:bg-[#00207A] transition-colors group">
            <div className="pg-overline text-white/60 mb-3">Ready to try it</div>
            <h3 className="font-heading text-xl font-bold tracking-tight">Sign up, Pro free right now</h3>
            <p className="text-sm text-white/70 mt-2 leading-relaxed">Two minutes from here to your first watched item.</p>
            <ArrowRight size={18} weight="bold" className="mt-4 group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link to="/about" className="bg-white p-8 hover:bg-white transition-colors group">
            <div className="pg-overline mb-3">More context</div>
            <h3 className="font-heading text-xl font-bold tracking-tight text-[#0a0a0a]">Why we built this</h3>
            <p className="text-sm text-[#52525b] mt-2 leading-relaxed">A short note from the team, plus our retailer-respectful operating principles.</p>
            <ArrowRight size={18} weight="bold" className="mt-4 text-[#0a0a0a] group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </section>
    </div>
  );
}
